"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
exports.__esModule = true;
var gateway_module_1 = require("../gateway-module");
var MarketingModule = /** @class */ (function (_super) {
    __extends(MarketingModule, _super);
    function MarketingModule() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * 批量发放优惠码
     *
     * @param promoCodeIds 优惠码id数组
     * @param issuer 发放人
     */
    MarketingModule.prototype.batchSendCoupons = function (promoCodeIds, issuer, token) {
        return this.gatewayClient.batchIssuedPromoCode(promoCodeIds, issuer, token);
    };
    /**
     * 通过cardId查询所有的码
     *
     * @param isReceive 1已领取2未领取，默认为0
     * @param isGrant 1已发放2未发放，默认为0
     * @param page
     * @param cardId
     * @param size
     * @param issueBeginTime 发放开始时间
     * @param issueEndTime 发放结束时间
     */
    MarketingModule.prototype.queryCouponByCardId = function (params, token) {
        return this.gatewayClient.getCodesByCardId(params, token);
    };
    return MarketingModule;
}(gateway_module_1.GatewayModule));
exports.MarketingModule = MarketingModule;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi8uLi9zcmMvYXBpcy9vbXMvbW9kdWxlcy9tYXJrZXRpbmcvaW5kZXgudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7O0FBRUEsb0RBQWtEO0FBRWxEO0lBQXFDLG1DQUFhO0lBQWxEOztJQW9DQSxDQUFDO0lBbkNDOzs7OztPQUtHO0lBQ0ksMENBQWdCLEdBQXZCLFVBQXdCLFlBQW9CLEVBQUUsTUFBYyxFQUFFLEtBQWE7UUFDekUsTUFBTSxDQUFDLElBQUksQ0FBQyxhQUFhLENBQUMsb0JBQW9CLENBQUMsWUFBWSxFQUFFLE1BQU0sRUFBRSxLQUFLLENBQUMsQ0FBQztJQUM5RSxDQUFDO0lBRUQ7Ozs7Ozs7Ozs7T0FVRztJQUNJLDZDQUFtQixHQUExQixVQUNFLE1BUUMsRUFDRCxLQUFhO1FBRWIsTUFBTSxDQUFDLElBQUksQ0FBQyxhQUFhLENBQUMsZ0JBQWdCLENBQUMsTUFBTSxFQUFFLEtBQUssQ0FBQyxDQUFDO0lBQzVELENBQUM7SUFDSCxzQkFBQztBQUFELENBQUMsQUFwQ0QsQ0FBcUMsOEJBQWEsR0FvQ2pEO0FBcENZLDBDQUFlIn0=


//////////////////
// WEBPACK FOOTER
// ./node_modules/xbed-api/lib/apis/oms/modules/marketing/index.js
// module id = 213
// module chunks = 44